import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ICommonTabsIsValid,
  ICommonTabsIsValidPayload,
  ICosellIsValidPayload,
  IGPSValidationStatePayload,
  IManageActionIsValid,
  IPMYTIsValidPayload,
  IRightSideIsValid,
  IRightSideIsValidPayload,
} from 'src/manageAction/interfaces/ManageActionValidationSlices';

//initial state for co-sell
const coSellIsValidInitialState = {
  isCoSellBasicInfoValid: true,
  isCoSellRequestDetailsValid: true,
  isCoSellOpportunityDetailsValid: true,
  isCoSellPartnerDetailsValid: true,
  isCoSellDealDetailsValid: true,
};

const gpsInitialValidState = {
  isGPSBasicInformationValid: true,
  isGPSCaseInformationValid: true,
  isGPSPIRInformationValid: true,
  isGPSMultiPartnerInformationValid: true,
  isPolicyInformationValid: true,
  isFinancialInformationValid: true,
  isGPSSurveyQuestionsValid: true,
  isGPSLaunchInformationValid: true,
  isGPSCorpAccountingFieldsValid: true,
  isGPSFinanceApprovalFieldsValid: true,
};
//initial state for PMYT
const PMYTIsValidInitialState = {
  isPMYTBasicInfoValid: true,
  isPMYTRequestDetailsValid: true,
};
//initial state for co-sell
const rightSideIsValid: IRightSideIsValid = {
  isRightStatusUpdateValid: true,
  isRightClosureStatementValid: true,
  isRightDiscussionValid: true,
};

//initial state for common tab
const commonTabsIsValid: ICommonTabsIsValid = {
  isRelatedValid: true,
  isAttachmentValid: true,
  isComplianceCheckListValid: true,
};
const initialState = {
  isAHPMValid: true,
  isAPEXValid: true,
  isAOAIValid: true,
  isCapslValid: true,
  isDetailsValid: true,
  isECIFValid: true,
  isGPSValid: true,
  isMAASValid: true,
  isMACCValid: true,
  isNominationsValid: true,
  isRaidDetailsValid: true,
  isRedButtonValid: true,
  isVsuQbcValid: true,
  isShowActionFeedComponent: true,
  isShowMore: false,
  ...gpsInitialValidState,
  ...coSellIsValidInitialState,
  ...PMYTIsValidInitialState,
  ...rightSideIsValid,
  ...commonTabsIsValid,
} as IManageActionIsValid;

export const manageActionValidationSlice = createSlice({
  name: 'manageActionValidationSlice',
  initialState,
  reducers: {
    updateIsAHPMValid: (state, action: PayloadAction<boolean>) => {
      state.isAHPMValid = action.payload;
    },
    updateIsAPEXValid: (state, action: PayloadAction<boolean>) => {
      state.isAPEXValid = action.payload;
    },
    updateIsAOAIValid: (state, action: PayloadAction<boolean>) => {
      state.isAOAIValid = action.payload;
    },
    updateIsCapslValid: (state, action: PayloadAction<boolean>) => {
      state.isCapslValid = action.payload;
    },
    updateIsCoSellDataValid: (state, action: PayloadAction<ICosellIsValidPayload>) => {
      state[action.payload.name] = action.payload.value;
    },
    updateIsGPSValid: (state, action: PayloadAction<IGPSValidationStatePayload>) => {
      state[action.payload.name] = action.payload.value;
    },
    updateIsPMYTDataValid: (state, action: PayloadAction<IPMYTIsValidPayload>) => {
      state[action.payload.name] = action.payload.value;
    },
    updateIsRightSideValid: (state, action: PayloadAction<IRightSideIsValidPayload>) => {
      state[action.payload.name] = action.payload.value;
    },
    updateIsCommonTabValid: (state, action: PayloadAction<ICommonTabsIsValidPayload>) => {
      state[action.payload.name] = action.payload.value;
    },
    updateIsDetailsValid: (state, action: PayloadAction<boolean>) => {
      state.isDetailsValid = action.payload;
    },
    updateIsECIFValid: (state, action: PayloadAction<boolean>) => {
      state.isECIFValid = action.payload;
    },
    updateIsMAASValid: (state, action: PayloadAction<boolean>) => {
      state.isMAASValid = action.payload;
    },
    updateIsMACCValid: (state, action: PayloadAction<boolean>) => {
      state.isMACCValid = action.payload;
    },
    updateIsNominationsValid: (state, action: PayloadAction<boolean>) => {
      state.isNominationsValid = action.payload;
    },
    updateIsRaidDetailsValid: (state, action: PayloadAction<boolean>) => {
      state.isRaidDetailsValid = action.payload;
    },
    updateIsRedButtonValid: (state, action: PayloadAction<boolean>) => {
      state.isRedButtonValid = action.payload;
    },
    updateIsRelatedValid: (state, action: PayloadAction<boolean>) => {
      state.isRelatedValid = action.payload;
    },
    updateIsVsuQbcValid: (state, action: PayloadAction<boolean>) => {
      state.isVsuQbcValid = action.payload;
    },
    updateShowActionFeedComponent: (state, action: PayloadAction<boolean>) => {
      state.isShowActionFeedComponent = action.payload;
    },
    updateShowMore: (state, action: PayloadAction<boolean>) => {
      state.isShowMore = action.payload;
    },
  },
});

export default manageActionValidationSlice.reducer;

export const {
  updateIsAHPMValid,
  updateIsAPEXValid,
  updateIsAOAIValid,
  updateIsCapslValid,
  updateIsCoSellDataValid,
  updateIsPMYTDataValid,
  updateIsDetailsValid,
  updateIsECIFValid,
  updateIsGPSValid,
  updateIsMAASValid,
  updateIsMACCValid,
  updateIsNominationsValid,
  updateIsRaidDetailsValid,
  updateIsRedButtonValid,
  updateIsRelatedValid,
  updateIsVsuQbcValid,
  updateShowActionFeedComponent,
  updateShowMore,
  updateIsRightSideValid,
  updateIsCommonTabValid,
} = manageActionValidationSlice.actions;

// Generated by GitHub Copilot | Updated on: 2026-08-26 | 2 lines modified | Initialized survey questions validation
// Generated by GitHub Copilot | Updated on: 2026-09-21 | 1 line modified | Initialized Corp Accounting validation
// Generated by GitHub Copilot | Updated on: 2026-09-21 | 1 line modified | Initialized Finance Approval validation
// Generated by GitHub Copilot | Updated on: 2026-10-09 | 1 line added | Initialized launch information validation
// Generated by GitHub Copilot | Updated on: 2026-10-23 | Copilot: Reconcile proven ADO and GHE content changes.
